import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandTaktikal(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path d="M19.23 3.03v3.002h-5.315V21.03h-3.772V6.032H4.829V3.03h14.4Z" fill="#1B223A" />
      <path
        d="M15.6 18.584a2.386 2.386 0 0 1 .692-1.691 2.383 2.383 0 0 1 1.707-.693c.335 0 .648.062.943.186a2.32 2.32 0 0 1 1.274 1.267c.122.293.184.604.184.931a2.34 2.34 0 0 1-.692 1.692c-.216.214-.472.38-.766.5-.295.118-.608.178-.943.178-.343 0-.66-.06-.95-.179a2.323 2.323 0 0 1-1.45-2.19Z"
        fill="#002CF2"
      />
    </BaseIcon>
  );
}
